export default __webpack_public_path__ + "static/University-of-StThomas_DSC5602-59542454d46356f836f939b44ad8aafa.jpg";